export default "/fonts/vendor/katex/dist/KaTeX_Main-Italic.ttf?fa675e5e4bec9eb250b6a8cac09b189b";